export default "__VITE_ASSET__DVdTO1B6__"